// @flow strict

import * as React from 'react';

type PropTypes = {|
  pathId: string,
|};

export default (props: PropTypes) => {
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://devcdn.vev.design/v/4998e5b3/embed.js`;

    if (document.head) {
      document.head.appendChild(script);
    }

    return () => {
      script.remove();
    };
  }, []);

  return <vevroot data-path={props.pathId} />;
};
